import request from "../../request";
import store from "../index";
import announces from "../../views/announces/Announces";

export default {
    state:{
      announces:[]
    },
    getters:{
      announcesGetter(state){
          return state.announces
      }
    },
    actions:{
        getAnnounces(state){
            request.get('announces').then(res=>{
                state.announces=res.data;
            });
            return request.get('announces');
        },
        deleteAnnounce(_,id){
            return request.delete('announces/'+id)
        },
        createAnnounce(_,payload){
            return request.post('announces',payload);
        },
        updateAnnounce(_,payload){
            return request.put('announces/'+payload.id,payload.item);
        }

    }
}